import type { CommunityBrandingFontConfig } from '@/store/communityStore';

interface BuiltinFontManifestEntry {
  key: string;
  label: string;
  load: () => Promise<unknown>;
}

export const builtinFontManifest: Record<string, BuiltinFontManifestEntry> = {
  portdequebec: {
    key: 'portdequebec',
    label: 'Port de Quebec',
    load: () => import('@/themes/page/portdequebec/fonts.css'),
  },
};

const loadedBuiltinFontKeys = new Set<string>();
const remoteFontLinks = new Map<string, HTMLLinkElement>();

function ensureRemoteFontLink(cssUrl: string) {
  if (remoteFontLinks.has(cssUrl)) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = cssUrl;
  link.dataset.ckFontSource = 'remote';
  document.head.appendChild(link);
  remoteFontLinks.set(cssUrl, link);
}

export async function syncBrandingFonts(fonts: CommunityBrandingFontConfig[]) {
  const nextRemoteUrls = new Set<string>();
  const nextBuiltinKeys = new Set<string>();

  for (const font of fonts) {
    if (font.source === 'remote-css' && font.css_url) {
      nextRemoteUrls.add(font.css_url);
      ensureRemoteFontLink(font.css_url);
    }

    if (font.source === 'builtin' && font.builtin_key) {
      nextBuiltinKeys.add(font.builtin_key);
    }
  }

  for (const [cssUrl, link] of remoteFontLinks.entries()) {
    if (!nextRemoteUrls.has(cssUrl)) {
      link.remove();
      remoteFontLinks.delete(cssUrl);
    }
  }

  for (const builtinKey of nextBuiltinKeys) {
    if (loadedBuiltinFontKeys.has(builtinKey)) {
      continue;
    }

    const manifestEntry = builtinFontManifest[builtinKey];
    if (!manifestEntry) {
      continue;
    }

    await manifestEntry.load();
    loadedBuiltinFontKeys.add(builtinKey);
  }
}

export function clearBrandingFonts() {
  for (const link of remoteFontLinks.values()) {
    link.remove();
  }
  remoteFontLinks.clear();
}
